import request from '@/utils/request'

// REQ-2026-632570 客诉反馈 —— 反馈类型配置接口
// 规格只约定了 /complaint/type/** 这个前缀，下面的子路径由前后端一起对齐
const apiPath = '/complaint/type'

const customerComplaintTypeApi = {
  /**
   * 分页查询【反馈类型配置】
   */
  fetchList(query) {
    return request.get(`${apiPath}/page`, { params: query })
  },
  /**
   * 下拉用：启用中的反馈类型（按 orderNo 升序）
   */
  findOptions(query) {
    return request.get(`${apiPath}/list`, { params: query })
  },
  /**
   * 查看详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/${id}`)
  },
  /**
   * 新增 / 编辑（有 id 即编辑）
   */
  save(data) {
    return request.post(`${apiPath}/save`, data)
  },
  /**
   * 删除单条
   */
  deleteById(id) {
    return request.post(`${apiPath}/delete`, { id })
  },
  /**
   * 启用 / 停用
   */
  setEnabled(data) {
    return request.post(`${apiPath}/setEnabled`, data)
  },
  /**
   * 上移 / 下移，direction: up | down
   */
  move(data) {
    return request.post(`${apiPath}/move`, data)
  },
  /**
   * 保存排序，入参为 [{ id, orderNo }]
   */
  saveOrder(list) {
    return request.post(`${apiPath}/saveOrder`, list)
  }
}

export default customerComplaintTypeApi
